export const COMPETENCY_SET_ELIGIBLE_EMPLOYEES = 'COMPETENCY_SET_ELIGIBLE_EMPLOYEES'
export const COMPETENCY_SET_ELIGIBLE_EMPLOYEES_PENDING = 'COMPETENCY_SET_ELIGIBLE_EMPLOYEES_PENDING'
export const COMPETENCY_SET_ELIGIBLE_EMPLOYEES_FULFILLED =
  'COMPETENCY_SET_ELIGIBLE_EMPLOYEES_FULFILLED'
export const COMPETENCY_SET_ELIGIBLE_EMPLOYEES_REJECTED =
  'COMPETENCY_SET_ELIGIBLE_EMPLOYEES_REJECTED'
